import { ReactElement, ReactNode, useCallback } from 'react'
import Table2 from 'components/molecules/tables/Table2'
import styles from 'components/features/rewards/rewardsPane/components/CryptoRewardsCurrencyPickerPreset/CryptoRewardsCurrencyPickerPreset.styl'

type CryptoRewardsCurrencyPickerPresetProps<R> = {
  isLoading: boolean
  children: R[]
  className?: string
  getRowKey (rowData: R): string
  getCurrencyIconByRowData (rowData: R): ReactNode
  getCurrencyDescriptionByRowData (rowData: R): ReactNode
  getSelectButtonByRowData (rowData: R): ReactNode
}

export function CryptoRewardsCurrencyPickerPreset<R> ({
  isLoading,
  children,
  className,
  getRowKey,
  getCurrencyIconByRowData,
  getCurrencyDescriptionByRowData,
  getSelectButtonByRowData,
}: CryptoRewardsCurrencyPickerPresetProps<R>): ReactElement {
  const renderRow = useCallback((rowData: R): ReactElement => {
    const rowKey = getRowKey(rowData)
    const iconNode = getCurrencyIconByRowData(rowData)
    const descriptionNode = getCurrencyDescriptionByRowData(rowData)
    const selectButtonNode = getSelectButtonByRowData(rowData)

    return (
      <Table2.Row key={ rowKey } className={ styles.tableRow }>
        <Table2.CellSimpleStyles rowKey={ rowKey } name='icon' className={ styles.tableCellIconColumn }>
          <div className={ styles.tableCellIconWrapper }>
            { iconNode }
          </div>
        </Table2.CellSimpleStyles>
        <Table2.CellSimpleStyles rowKey={ rowKey } name='description'>
          { descriptionNode }
        </Table2.CellSimpleStyles>
        <Table2.CellSimpleStyles rowKey={ rowKey } name='action' className={ styles.currencySelectButtonColumn }>
          { selectButtonNode }
        </Table2.CellSimpleStyles>
      </Table2.Row>
    )
  }, [getRowKey, getCurrencyIconByRowData, getCurrencyDescriptionByRowData, getSelectButtonByRowData])

  return (
    <Table2
      className={ className }
      getRowKey={ getRowKey }
      rows={ children }
      isLoading={ isLoading }
    >
      <Table2.Rows>
        <Table2.RowTemplate>
          { renderRow }
        </Table2.RowTemplate>
      </Table2.Rows>
    </Table2>
  )
}
